import z from 'zod';

const descriptions = {
  src: `The source path of the content file to include. 
The path must:
- Be prefixed with a leading slash character: /
- Retain the extension .mdx or .md
- Omit the locale (e.g., do not include /en-US/ in the path)

Included MDX files must be placed under: content/<namespace>/en-US/includes/

For example, to include 'content/cloud/en-US/includes/example-include.mdx', use:
<Include src="/cloud/includes/example-include.mdx" />

The locale of the included content will be inferred from the page that contains the reference.`,
  schema: `Include content from another file in your MDX document.
This component allows you to include content from other MDX files, making it easier to reuse and organize your documentation.
Included files must be placed under content/<namespace>/en-US/includes/.`,
};

export const includeSchema = z
  .object({
    src: z.string().describe(descriptions.src),
  })
  .describe(descriptions.schema);
